// Returns a human-readable current month + year, e.g. "April 2026"
export function currentMonthYear() {
  const d = new Date();
  return d.toLocaleDateString("en-GB", { month: "long", year: "numeric" });
}

// Full current date, e.g. "21 April 2026"
export function currentFullDate() {
  const d = new Date();
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}
